
import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { EventFormValues } from '../schemas/eventFormSchema';
import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormMessage,
  FormDescription,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { FileText } from "lucide-react";

interface BasicEventInfoProps {
  form: UseFormReturn<EventFormValues>;
}

const BasicEventInfo = ({ form }: BasicEventInfoProps) => {
  return (
    <Card className="border-2 border-medihub-primary/20">
      <CardHeader className="bg-medihub-primary/10 pb-2">
        <CardTitle className="text-lg flex items-center gap-2 text-medihub-primary">
          <FileText className="h-5 w-5" />
          Alapinformációk
        </CardTitle>
      </CardHeader>
      <CardContent className="pt-4 space-y-4">
        <FormField
          control={form.control}
          name="eventName"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Esemény neve*</FormLabel>
              <FormControl>
                <Input placeholder="Adja meg az esemény nevét" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="description"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Leírás</FormLabel>
              <FormControl>
                <Textarea
                  placeholder="Opcionálisan részletes leírást adhat az eseményről"
                  className="min-h-32"
                  {...field}
                />
              </FormControl>
              <FormDescription>
                Opcionális, részletes leírást adhat az eseményről                  </FormDescription>

              <FormMessage />
            </FormItem>
          )}
        />
      </CardContent>
    </Card>
  );
};

export default BasicEventInfo;
